import { STD_LINK } from "@/utils/enum";
import { Box } from "@mui/material";
import Image from "next/image";
import Link from "next/link";
import { CSSProperties, memo } from "react";

interface Props {
  customStyles?: CSSProperties;
  href?: string;
  src?: string;
  alt?: string;
  target?: "_blank" | "_self";
}

const DEFAULT_CUSTOM_STYLES: CSSProperties = {};

function LinkedImageBanner({
  customStyles = DEFAULT_CUSTOM_STYLES,
  href = STD_LINK,
  src = "/images/banner-special-price.png",
  alt = "特別価格キャンペーン",
  target = "_blank"
}: Props) {
  const rel = target === "_blank" ? "noopener noreferrer" : undefined;

  return (
    <Link href={href} style={{ width: "100%" }} target={target} rel={rel}>
      <Box width={1} paddingX={2} style={customStyles}>
        <Image
          src={src}
          alt={alt}
          priority={true}
          loading="eager"
          width={0}
          height={0}
          sizes="100vw"
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover"
          }}
        />
      </Box>
    </Link>
  );
}

export default memo(LinkedImageBanner);
